const skipCF = (new URLSearchParams(window.location.search)).get('ws-cf') === '0';
module.exports = {
    apiServerUrl: 'https://api.amplement.io',
    publicHostname: 'https://www.amplement.com',
    websocketHostname: skipCF ? 'https://api.amplement.com' : 'https://api.amplement.io',
    debug: false,
    logLevel: 'warn',
};
